<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" :rules="rules" ref="queryParams" class="form" size="small" label-width="100px">
					<el-form-item label="日期范围" prop="createDates">
						<el-date-picker v-model="queryParams.createDates" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" align="right" value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleSearch">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd">设置储罐名称</el-button>
					</el-form-item>
				</el-form>
			</el-col>


			<el-col :span="24">
				<div ref="chart" style="width: 100%; height: 500px"></div>
			</el-col>

			<div class="head">
				<span>入库明细</span>
				<el-button type="primary" size="small" @click="handleStoreAdd">手动添加</el-button>
			</div>
			<!-- 列表 -->
			<el-col style="padding-right: 50px;">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange">
					<el-table-column prop="id" label="序号" width="60">
						<template slot-scope="scope">
							{{scope.$index |fromatIndex}}
						</template>
					</el-table-column>
					<el-table-column prop="chemicalsCode" label="化学品代号"></el-table-column>
					<el-table-column prop="chemicalsTitle" label="标签"></el-table-column>
					<el-table-column prop="value" label="到达量(公斤)"></el-table-column>
					<el-table-column prop="addTime" label="到达时间"></el-table-column>
					<el-table-column prop="createTime" label="添加时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="160">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleStoreEdit(scope.row)">编辑</el-button>
							<el-button size="mini" type="primary" @click="handleStoreDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<el-dialog title="设置储罐名称" :visible.sync="dialogVisible" width="650px" :close-on-click-modal="false">
			<el-form :model="addOrUpdateForm" :inline="true" :rules="rules" ref="addOrUpdateForm" label-width="80px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="#1名称" prop="type1">
							<el-select v-model="addOrUpdateForm.type1" clearable filterable placeholder="请选择化学品代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="#2名称" prop="type2">
							<el-select v-model="addOrUpdateForm.type2" clearable filterable placeholder="请选择化学品代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="#3名称" prop="type3">
							<el-select v-model="addOrUpdateForm.type3" clearable filterable placeholder="请选择化学品代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
							</el-input></el-form-item>
						<el-form-item label="#4名称" prop="type4">
							<el-select v-model="addOrUpdateForm.type4" clearable filterable placeholder="请选择化学品代号">
								<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="saveConfig()">确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :title="title" :visible.sync="dialogStoreVisible" width="700px" :close-on-click-modal="false">
			<el-form :inline="true"  :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="120px">
		        <el-form-item label="化学品代号" prop="chemicalsCode">
					<el-select v-model="addOrUpdateForm.chemicalsCode" filterable placeholder="请选择化学品代号">
						<el-option v-for="item in chemicalsList" :key="item.code" :label="item.code" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
		        <el-form-item label="到达量" label-width="80px" prop="value">
					<el-input type="text" v-model="addOrUpdateForm.value" style="width:150px;margin-right: 5px;"></el-input>公斤
				</el-form-item>
		        <el-form-item label="入库时间" prop="addTime">
		            <el-date-picker v-model="addOrUpdateForm.addTime" style="width:205px" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"  placeholder="选择入库时间"> </el-date-picker>
		        </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogStoreVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="saveLog">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import * as echarts from 'echarts';

	const labelOption = {
		show: true,
		position: 'top',
		formatter: '{c}',
		fontSize: 12,
		rich: {
			name: {}
		}
	};

	export default {
		extends: BaseSearch,
		props: ['templateId', 'deviceId', 'variableId', 'variableTitle', 'device'],
		data() {
			return {
				chemicalsList: [],
				url: '/mngr/chemicals/device/store',
				name: '化学品到达量',
				updateUrl :'',
				rules: {
					createDates: [{
						required: true,
						message: '请选择日期范围',
						trigger: 'blur',
						validator: this.checkArrayNotEmpty
					}],
				},
				autoQuery: false,
				loading: false,
				dialogStoreVisible:false,
				pickerOptions: {
					shortcuts: [{
						text: '最近7天',
						onClick(picker) {
							const end = new Date();
							end.setTime(end.getTime());
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const end = new Date();
							end.setTime(end.getTime());
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}],
					disabledDate(time) {
						const now = new Date();
						const thirtyDaysAgo = new Date(now.getTime() - 31 * 24 * 60 * 60 * 1000); // 30天前
						return time.getTime() < thirtyDaysAgo.getTime() || time.getTime() > now.getTime();
					}
				},
				chartOptions: {
					formatter: function(params) {
						if (Array.isArray(params)) {
							let result = ''; // 显示横坐标值（如 Mon）
							params.forEach(param => {
								// 从数据点对象中获取所有指标
								const data = param.data;
								result += `${param.seriesName}<br/>液位/最大液位 ${data.currentLevel!=null?data.currentLevel:'-'}/${data.maxLevel!=null?data.maxLevel:'-'}<br/>${data.consume!=null?data.consume:'-'}<br/><br/>`;
							});
							return result;
						} else {
							return params
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						show: true,
					},
					legend: {
						data: [],
						bottom: 0 // 将 legend 放到图表下方
					},
					toolbox: {
						show: false
					},
					grid: {
						left: "50px",
						right: "40px",
						top: "20px"
					},
					xAxis: [{
						type: 'category',
						axisTick: {
							show: false
						},
						data: []
					}],
					yAxis: [{
						type: 'value'
					}],
					series: []
				},
				myChart: null
			};
		},
		filters: {
			fromatIndex(index) {
				return index + 1
			}
		},
		methods: {
			saveConfig(){
				this.success_message="设置成功";
				this.handleUpdate();
			},
			saveLog(){
				this.success_message="";
				this.handleUpdate();
			},
			setDefaultTimeRange() {
				const now = new Date(); // 当前时间
				const twoHoursAgo = new Date(now.getTime() - 3600 * 1000 * 24 * 7); // 7天
				const startTime = this.formatDate(twoHoursAgo);
				const endTime = this.formatDate(now);
				this.queryParams.createDates = [startTime, endTime];
				this.$forceUpdate(); // 强制更新组件
			},
			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			checkArrayNotEmpty(rule, value, callback) {
				value = this.queryParams[rule.field]
				if (value && value.length > 0) {
					callback();
				} else {
					callback(new Error(rule.message));
				}
			},
			handleAdd() {
				this.updateUrl='mngr/chemicals/device/config/update'
				this.$http({
					method: 'GET',
					url: 'mngr/chemicals/device/config/detail?deviceId=' + this.device.id,
				}).then((res) => {
					//重置表单
					if (this.$refs.addOrUpdateForm != undefined) {
						this.$refs['addOrUpdateForm'].resetFields();
					}
					this.addOrUpdateForm = res.data.data;
					this.dialogVisible = true;
				})
			},
			beforeUpdate(){
				this.addOrUpdateForm.deviceId=this.deviceId
				this.addOrUpdateForm.institutionId=this.device.institutionId
			},
			handleStoreAdd(){
				//添加弹窗
				//重置表单
				this.updateUrl=''
				if (this.$refs.addOrUpdateForm != undefined) {
					this.$refs['addOrUpdateForm'].resetFields();
				}
				this.createUpdateForm(this.getAddData());
				this.beforeEdit();
				this.title = '添加' + this.name;
				this.dialogStoreVisible = true;
			},
			handleStoreEdit(row) {
				//编辑弹窗
				//重置表单
				this.updateUrl=''
				if (this.$refs.addOrUpdateForm != undefined) {
					this.$refs['addOrUpdateForm'].resetFields();
				}
				this.createUpdateForm(row);
				this.beforeEdit(true);
				this.title = '编辑' + this.name;
				this.dialogStoreVisible = true;
			},
			handleStoreDelete(row) {
				//删除
				this.updateUrl=''
				this.updateStatus(-1, '删除',row.id);
			},
			handleSearch() {
				this.$refs['queryParams'].validate(valid => {
					if (valid) {
						this.queryDatas();
						this.handleQuery()
					} else {
						return false;
					}
				});
			},
			queryAllChemicals() {
				this.$http({
					method: 'POST',
					url: 'mngr/chemicals/query',
					data: {
						currentPage: 1,
						pageSize: 10000,
						state:1,
						institutionId: this.device.institutionId
					},
				}).then((res) => {
					this.chemicalsList = res.data.data;
				})
			},
			afterUpdate(){
				this.handleSearch()
				this.dialogStoreVisible=false
			},
			beforeQuery() {
				this.queryUrl = "/query"
				this.queryParams.deviceId = this.deviceId
			},
			queryDatas() {
				this.$http({
					method: 'POST',
					url: 'mngr/chemicals/device/log/getChartDatas',
					data: this.queryParams,
				}).then((res) => {
					console.log(res.data.data)
					if (res.data.data) {
						this.chartOptions.xAxis[0].data = res.data.data.xaxis;
						this.chartOptions.legend.data = []

						var series = []
						res.data.data.series.forEach(item => {
							this.chartOptions.legend.data.push(item.name);
							series.push({
								name: item.name,
								type: 'line',
								barMaxWidth: 30,
								label: labelOption,
								data: item.datas
							})
						});
						this.chartOptions.series = series;
					} else {
						this.chartOptions.legend.data = []
						this.chartOptions.xAxis[0].data = [];
						this.chartOptions.series = [];
					}
					console.log(JSON.stringify(this.chartOptions))
					this.$nextTick(() => {
						console.log(this.chartOptions)
						this.myChart.setOption(this.chartOptions, {
							notMerge: true
						});
						this.myChart.resize();
					});

				})
			}
		},
		mounted: function() {
			var chartDom = this.$refs.chart;
			this.myChart = echarts.init(chartDom);
			this.myChart.setOption(this.chartOptions, {
				notMerge: true
			});
			this.queryAllChemicals();
			console.log("this.deviceId", this.deviceId);
			this.queryParams.deviceId = this.deviceId
			this.setDefaultTimeRange();
			this.handleSearch();
		}
	};
</script>



<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	.form {
		margin: 0px;
		margin-top: 10px;
	}

	.contents {
		margin: 0px;
		padding-left: 10px;
	}

	.head {
		margin: 10px 0px;
	}

	/deep/ .el-range-editor--small .el-range-separator {
		line-height: 24px;
		font-size: 13px;
		width: 50px;
	}

	/* 
	/deep/ .el-date-editor.el-input__inner,
	.handleQuery .el-date-editor.el-input {
		width: 380px !important;
		;
	} */
</style>


// WEBPACK FOOTER //
// src/view/system/chemicalsDeviceStatistics.vue